function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { Route, matchPath } from 'react-router-dom';

import RouteTransition from './RouteTransition';

/**
 * Here we only care about whether or not the pathname matches. If so,
 * we'll use the route's path as the key, otherwise we'll default it
 * to a string signifying no match.
 */
function getKey(_ref, path, exact) {
  var pathname = _ref.pathname;

  return matchPath(pathname, { exact: exact, path: path }) ? 'match' : 'no-match';
}

var AnimatedRoute = function AnimatedRoute(_ref2) {
  var component = _ref2.component,
      path = _ref2.path,
      exact = _ref2.exact,
      routeTransitionProps = _objectWithoutProperties(_ref2, ['component', 'path', 'exact']);

  return React.createElement(Route, {
    render: function render(_ref3) {
      var location = _ref3.location,
          match = _ref3.match;
      return React.createElement(
        RouteTransition,
        routeTransitionProps,
        React.createElement(Route, {
          key: getKey(location, path, exact),
          path: path,
          exact: exact,
          location: location,
          component: component
        })
      );
    }
  });
};

export default AnimatedRoute;


//////////////////
// WEBPACK FOOTER
// ./~/react-router-transition/es/AnimatedRoute.js
// module id = 372
// module chunks = 4